import styled from 'styled-components';

export const ToolsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export default ToolsContainer;
